import React, { useEffect, useState } from "react";
import { Box, Button, Modal, Paper, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import BarterGinie from "./assets/GPTImages/GPTCartoon.svg";
import BarterGinieFace from "./assets/GPTImages/gptface.svg";
import { motion } from "framer-motion";
import sendEvents from "./utils/sendEvents";
import NewBarterGPTUI from "./components/Sidebar/NewBarterGPTUI";
import { Close } from "@mui/icons-material";
import "./index.css";

function BarterGptLandingPage(props) {
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/createaccount" ||
      window.location.pathname === "/login" ||
      window.location.pathname === "/learnbarter" ||
      window.location.pathname === "/about" ||
      window.location.pathname === "/explore" ||
      window.location.pathname === "/blogpage" ||
      window.location.pathname === "/marketplace" ||
      window.location.pathname.includes("advantages-and") ||
      window.location.pathname.includes("difference-between") ||
      window.location.pathname.includes("barter-exchange") ||
      window.location.pathname.includes("barter-trade")
    ) {
      setDisplay(true);
    } else {
      setDisplay(false);
    }
  }, [window.location.pathname]);

  return (
    <React.Fragment>
      <Box>
        {display ? (
          <Box sx={OutLetBoxStyle}>
            <Outlet />
            <motion.div
              animate={{ y: [0, -15, 0] }}
              transition={{
                repeat: Infinity,
                duration: 2.5,
                ease: "easeInOut",
              }}
              style={{
                position: "fixed",
                zIndex: 100,
                right: "1.5%",
                bottom: "2%",
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={BarterGinie}
                sx={{
                  position: "absolute",
                  zIndex: 100,
                  width: {
                    xl: "100px",
                    lg: "100px",
                    md: "100px",
                    sm: "55px",
                    xs: "55px",
                  },
                  height: {
                    xl: "100px",
                    lg: "100px",
                    md: "100px",
                    sm: "55px",
                    xs: "55px",
                  },
                  right: {
                    xl: "1.5%",
                    lg: "1.5%",
                    md: "1.5%",
                    sm: "0%",
                    xs: "0%",
                  },
                  bottom: "2%",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (display) {
                    handleOpen();
                    sendEvents("Click on ginie");
                  }
                }}
              />
            </motion.div>
            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal-box">
                <Typography
                  onClick={handleClose}
                  sx={{
                    fontSize: "clamp(16px, 2vw, 22px)",
                    color: "#fff",
                    cursor: "pointer",
                    position: "absolute",
                    right: "0px",
                    top: "-35px",
                    zIndex: 1000,
                    background: "#445FD2",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center", // Center the content
                    alignItems: "center", // Vertically center the content
                    borderRadius: "50%", // Make it round
                    boxShadow: "0 4px 6px rgba(167, 165, 165, 0.1)", // Optional: Add shadow for depth
                  }}
                >
                  {/* You can conditionally render either Close or ArrowDownward */}
                  <Close fontSize="15px" color="#fff" />
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "clamp(60px, 12vh, 85px)",
                    background: "#445FD2",
                    borderRadius: "20px 20px 0px 0px",
                    px: "16px",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: "white",
                        fontSize: "clamp(14px, 1vw, 16px)",
                      }}
                    >
                      Barter AI
                    </Typography>
                    <Typography
                      sx={{
                        color: "white",
                        fontSize: "clamp(12px, 1vw, 14px)",
                      }}
                    >
                      Your AI Partner to Smart Bartering!
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Button>
                      <Box
                        component={"img"}
                        src={BarterGinieFace}
                        sx={{
                          width: "auto",
                          height: "auto",
                          minWidth: "70px",
                          maxWidth: "70px",
                        }}
                      />
                    </Button>
                  </Box>
                </Box>
                <NewBarterGPTUI />
              </Box>
            </Modal>
          </Box>
        ) : (
          <Paper
            sx={{
              bgcolor: "transparent",
              borderRadius: "30px",
              overflowY: "scroll",
              background: "red",
            }}
            elevation={0}
          ></Paper>
        )}
      </Box>
    </React.Fragment>
  );
}

export default BarterGptLandingPage;

const OutLetBoxStyle = {
  maxWidth: "2000px",
  width: "96%",
  mx: "auto",
  bgcolor: "transparent",
  position: "relative",
  background: "green",
};

const style = {
  position: "fixed",
  top: {
    xl: "22%",
    lg: "22%",
    md: "22%",
    sm: "22%",
    xs: "22%",
  },
  right: {
    xl: "-10%",
    lg: "-10%",
    md: "-10%",
    sm: "-10%",
    xs: "-30%",
  },
  transform: {
    sm: "translateX(-50%)",
    xs: "translateX(-50%)",
  },
  width: {
    xl: "420px",
    lg: "420px",
    md: "400px",
    sm: "400px",
    xs: "320px",
  },
  height: {
    xl: "65%",
    lg: "65%",
    md: "65%",
    sm: "65%",
    xs: "67%",
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
  p: 0,
};
